<template>
  <div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <logo :collapse="isCollapse" />
      <el-menu  :default-active="activeMenu" :collapse="true" :background-color="variables.menuBg"
        :text-color="variables.menuText" :active-text-color="variables.menuActiveText" :unique-opened="true"
        :collapse-transition="false" mode="vertical">
        <sidebar-item v-for="route in $store.state.sys.permissionRouters" :key="route.path" :item="route"
          :base-path="route.path" />
      </el-menu>
    </el-scrollbar>

  </div>
</template>
<style  scoped>
/* 文字 */
.is-active {
  color: #409eff !important;
}

</style>

<script>
import variables from "@/styles/variables.scss";
import logo from "./logo";
import sidebarItem from "./sidebarItem";

export default {
  components: {
    sidebarItem,
    logo
  },
  data() {
    return {
      operationDialog: false,
      contactDialog: false,
      headerHeight: "120px",
      openedMenus: [],
      currentMenus: [],
      menuPath: "",
      maxShowHeaderMenu: 0,
      path: "",
    };
  },
  mounted(){
console.log(this.$store.state.sys.permissionRouters)
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      // if(this.$store.state.isMB){
      //   this.$store.dispatch("MBtoggleSideBar");
      // }
      return path;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.$store.state.app.sidebar.opened;
    }
  }
};
</script>